import { useEffect } from "react";

export const useStyleTabs = () => {
  useEffect(() => {
    let attempts = 0;
    let id: number;

    const detectList = () => {
      id = setTimeout(() => {
        const tabs = document.querySelector("atomic-tab-manager");
        if (tabs) {
          const list = tabs.shadowRoot.querySelector("ul");
          const select = tabs.shadowRoot.querySelector("select");
          if (!list && !select && attempts < 10) {
            attempts++;
            detectList();
          } else if (list && select) {
            list.setAttribute("part", "custom-list");
            select.setAttribute("part", "custom-select");
            select?.parentElement?.setAttribute(
              "part",
              "custom-select-container"
            );
            attempts = 0;
          }
        }
      }, 100) as unknown as number;
    };

    detectList();

    return () => {
      clearTimeout(id);
    };
  }, []);
};
